export default "__VITE_ASSET__555b1f9f__"